import { render, staticRenderFns } from "./FormboxSampling.vue?vue&type=template&id=7e9e1296&"
import script from "./FormboxSampling.vue?vue&type=script&lang=js&"
export * from "./FormboxSampling.vue?vue&type=script&lang=js&"
import style0 from "./FormboxSampling.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports